// @ts-nocheck
import React from 'react';
import { FormattedMessage as T, Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const ReconcileCustomerDepositsDialogContent = React.lazy(() =>
  import('./ReconcileCustomerDepositsDialogContent'),
);

/**
 * Reconcile customer deposits dialog.
 */
function ReconcileCustomerDepositsDialog({
  dialogName,
  payload: { customerDepositsId },
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title={<T id={'reconcile_customer_deposits.label'} />}
      canEscapeKeyClose={true}
      isOpen={isOpen}
      className="dialog--reconcile-credit-form"
    >
      <DialogSuspense>
        <ReconcileCustomerDepositsDialogContent
          customerDepositsId={customerDepositsId}
          dialogName={dialogName}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(ReconcileCustomerDepositsDialog);
